export default "__VITE_ASSET__gvyTjkhp__"